import { InternalPropertyApiBase } from './base';

export class InternalPropertyApi extends InternalPropertyApiBase {
  get(propertyId) {
    return super.get(`${propertyId}`, 'Could not retrieve the property');
  }
}
